/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScreenerSourceAllowName
 */
export interface ScreenerSourceAllowName {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    organization_id: string;
    /**
     * 
     */
    facility_id: string;
    /**
     * 
     */
    integration_type: string;
    /**
     * 
     */
    source_name: string;
}

/**
 * Check if a given object implements the ScreenerSourceAllowName interface.
 */
export function instanceOfScreenerSourceAllowName(value: object): value is ScreenerSourceAllowName {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('integration_type' in value) || value['integration_type'] === undefined) return false;
    if (!('source_name' in value) || value['source_name'] === undefined) return false;
    return true;
}

export function ScreenerSourceAllowNameFromJSON(json: any): ScreenerSourceAllowName {
    return ScreenerSourceAllowNameFromJSONTyped(json, false);
}

export function ScreenerSourceAllowNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerSourceAllowName {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organization_id': json['organization_id'],
        'facility_id': json['facility_id'],
        'integration_type': json['integration_type'],
        'source_name': json['source_name'],
    };
}

export function ScreenerSourceAllowNameToJSON(json: any): ScreenerSourceAllowName {
    return ScreenerSourceAllowNameToJSONTyped(json, false);
}

export function ScreenerSourceAllowNameToJSONTyped(value?: ScreenerSourceAllowName | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'organization_id': value['organization_id'],
        'facility_id': value['facility_id'],
        'integration_type': value['integration_type'],
        'source_name': value['source_name'],
    };
}

